import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import ServiceSectionS3 from '../../components/ServiceSectionS3/ServiceSectionS3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Navbar2 from '../../components/Navbar2/Navbar2'
import Logo from '../../images/logo2.png'

const ServicePage = () => {
    return (
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-1'} Logo={Logo} />
            <PageTitle pageTitle={'Hizmetlerimiz'} pagesub={'Hizmetlerimiz'} />
            <ServiceSectionS3 />
            {/* <Subscribe sbClass={'wpo-subscribe-section-s2 pt-0'} /> */}
            {/* <Subscribe sbClass={s'wpo-subscribe-section-s2 pt-0'} /> */}
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;

